//文字コードはutf-8

import { initHamburgerMenu } from './modules/hamburger.js';
import { headerDropDown } from './modules/headerDropDown.js';
import { headerScrolling } from './modules/headerScrolling.js';
import { initSmoothScroll } from './modules/smoothScroll.js';
import { initCategorySelect } from './modules/categorySelect.js';
import { initYoutube } from './modules/youtube.js';
import { initFaqAccordion } from './modules/faqAccordion.js';
import { setScrollbarWidth } from './modules/scrollbarWidth.js';
import { setSimplebar } from './modules/simplebar.js';
import { initFloatBlockList } from './modules/floatBlockList.js';
import { initTabletScale } from './modules/tabletScale.js';
import { initHeaderSearch } from './modules/headerSearch.js';
import './modules/topKvSlider.js';

// DOMが完全に読み込まれているか確認
const init = () => {
  setScrollbarWidth();
  initTabletScale();
  initHamburgerMenu();
  headerDropDown();
  headerScrolling();
  initSmoothScroll();
  initCategorySelect();
  initYoutube();
  initFaqAccordion();
  setSimplebar();
  initFloatBlockList();
  initHeaderSearch();
};

// DOMの状態に応じて実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
